import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource, ImageOptions } from '@capacitor/camera';

@Injectable({
  providedIn: 'root',
})
export class CameraImageService {
  constructor() {}

  public async getPictureFromCamera(): Promise<string> {
    const options: ImageOptions = {
      resultType: CameraResultType.Base64,
      source: CameraSource.Camera,
      allowEditing: false,
      saveToGallery: false,
      quality: 50,
      width: 1024,
      height: 1024,
      correctOrientation: true,
    };
    await this.checkCameraPermissions();
    // If camera gets closed an excpetion is thrown, which needs to be handled
    const image = await Camera.getPhoto(options);
    return `data:image/jpeg;base64,${image.base64String}`;
  }

  public async getPictureFromGallery(): Promise<string> {
    const options: ImageOptions = {
      resultType: CameraResultType.Base64,
      source: CameraSource.Photos,
      allowEditing: false,
      saveToGallery: false,
      quality: 50,
      width: 1024,
      height: 1024,
      correctOrientation: true,
    };
    // If Gallery is closed an exception is thrown that needs to be handled
    const image = await Camera.getPhoto(options);
    return `data:image/jpeg;base64,${image.base64String}`;
  }

  private async checkCameraPermissions(): Promise<void> | never {
    let permissions = await Camera.checkPermissions();

    if (permissions.camera !== 'granted' && permissions.camera !== 'denied') {
      permissions = await Camera.requestPermissions({ permissions: ['camera'] });
    }

    if (permissions.camera === 'denied') {
      throw new Error('Camera Permission missing!');
    }
  }

  // public imageDataToBlob(imageData): Observable<any> {
  //   return Observable.fromPromise(this.file.resolveLocalFilesystemUrl(imageData))
  //     .flatMap((fileEntry: FileEntry) => {
  //       return this.fileEntryToObservable(fileEntry);
  //     })
  //     .flatMap(file => {
  //       return this.fileReaderToObservable(file);
  //     });
  // }

  // public fileEntryToObservable(fileEntry: any): Observable<any> {
  //   return Observable.create(observer => {
  //     fileEntry.file(
  //       function(file) {
  //         observer.next(file);
  //       },
  //       function(error) {
  //         observer.error(error);
  //       },
  //     );
  //   });
  // }

  // public fileReaderToObservable(file: any): Observable<any> {
  //   const fileReader = new FileReader();
  //   fileReader.readAsArrayBuffer(file);
  //   return Observable.create(observer => {
  //     fileReader.onload = () => {
  //       observer.next(new Blob([fileReader.result], { type: file.type }));
  //     };
  //     fileReader.onerror = error => observer.error(error);
  //   });
  // }
}
